// extracted by mini-css-extract-plugin
module.exports = {"root":"PageHeader_root__2-J4m","searchInput":"PageHeader_searchInput__1vDug"};